module.exports = __webpack_public_path__ + "static/media/DK_Layout_3.c5ad202d.png";